module.exports = __webpack_public_path__ + "static/img/3.6c960ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/3.png
// module id = kVs5
// module chunks = 1 3